import React, { useContext } from 'react';
import '../../assets/scss/components/common/errorfallback.scss';
import * as API from '../../api/Service.js'
import { EmbedSiteShortContext } from '../../App.js';
import * as Utils from '../../common/Utils.js';

export default function ErrorFallback({error, resetErrorBoundary})
{
    const errorID = crypto.randomUUID();
    const site = useContext(EmbedSiteShortContext);

    let errorData = { 
        "path": window.location.pathname+window.location.search, 
        "errorData": error.stack ?? "",
        "message": error.message ?? "", 
        "errorid": errorID, 
        "site": useContext(EmbedSiteShortContext)
    };

    let jsonErrorData = Utils.tryJsonParse(error.message ?? "{}");

    // if API error, include extra info about what's gone one
    if (jsonErrorData?.data?.errors)
    {
        errorData.errorData = JSON.stringify(jsonErrorData.data.errors);
        errorData.message = `React API Error: Status: ${jsonErrorData.data.status} Message: ${jsonErrorData.data.title}`;
    }

    const fetchErrorRefetch = API.useRefetchQuery("FetchError", "/error/weberror", 2, errorData);

    fetchErrorRefetch()
        .then((response) =>
        {
            if (response?.data?.errors && Object.keys(response.data.errors).length > 0)
            {
                throw new Error(`Status: ${response.data.status}. Message: ${response.data.title}. Errors: ${JSON.stringify(response.data.errors)}`);
            }

            return response.data;
        })
        .then((data) =>
        {
            // error logged ok
            //console.log(data);

            return true; // call finished
        })
        .catch((error) =>
        {
            // something went wrong logging the error, try re-throw a simpler one
            //console.log(error);
            throw new Error(error);
            //throw new Error("Unable to log error - code debug needed");
        });

    let ITEmailAddress = "at ";

    if (site === 'chillblast')
        ITEmailAddress += "support@chillblast.com";
    else if (site === 'ccl')
        ITEmailAddress += "websupport@cclonline.com";
    else
        ITEmailAddress = "";

    return (
	    <div className="mt-5 mx-auto p-2 p-sm-3 p-md-4 p-lg-5">
            <h1 className="error-text mb-3">Your Build Has Expired</h1>

            <h3 className="error-text mb-3">Please start a new build or return to the main menu using the buttons below.</h3>

            <button className="error-cta-btn primary-button text-end p-3" onClick={() => window.location.href = window.location.pathname}>Start New Build</button>
            
            <a className="secondary-error-btn error-cta-btn btn button text-end p-3 primary-underline-link text-muted-light" href='/'>Go Back</a>
        </div>
    );
}